module.exports = __webpack_public_path__ + "img/memoji-happy.ad91ef21.png";